export default "__VITE_ASSET__CmSSJF9V__"